import * as core from '@interopio/gateway/logging/core';

export function getLogger(name: string) {
    return core.getLogger(name);
}
